import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import gl from '../assets/icons/gl.png';
import uk from '../assets/icons/uk.png';
import de from '../assets/icons/de.png';
import es from '../assets/icons/es.png';
import "../styles/Header.css"

function LanguageSelector() {
  const { language, switchLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const languageOptions = [
    { code: 'es', label: 'Español', icon: es },
    { code: 'en', label: 'English', icon: uk },
    { code: 'de', label: 'Deutsch', icon: de },
    { code: 'gl', label: 'Galego', icon: gl },
  ];

  const currentLang = languageOptions.find(l => l.code === language);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="language-dropdown-container">
      <button
        ref={buttonRef}
        className="language-dropdown-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change language"
      >
        <img
          src={currentLang ? currentLang.icon : uk}
          alt={currentLang ? currentLang.label : 'Language'}
          className="language-flag-icon"
        />
      </button>
      {isOpen && (
        <div
          className="language-dropdown-menu"
          ref={menuRef}
        >
          {languageOptions.map((option) => (
            <div
              key={option.code}
              className="language-dropdown-item"
              onClick={() => {
                switchLanguage(option.code);
                setIsOpen(false);
              }}
            >
              <img
                src={option.icon}
                alt={option.label}
                className="language-flag-icon"
              />
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector;
